import axios from 'axios'
import { userUrl, roleUrl, getHeader, jobPositionUrl } from './../config'

const state = {
  positions: [],
  authUser: {
    permissions: {
      master: false,
      product: false,
      customer: false,
      vendor: false,
      inventory: false,
      sales: false,
      workshop: false,
      finance: false,
      purchasing: false,
      accounting: false,
      settings: false,
      workshops: false
    }
  },
  userAll: [],
  todos: [
    { id: 1, no: 1, name: 'Tirta Mulya', email: 'tmulya@gmail.com' },
    { id: 2, no: 2, name: 'Pramanda', email: 'pramandatirta@gmail.com' }
  ],
  roles: []
}

const mutations = {
  SET_POSITION_USER (state, obj) {
    state.positions = obj
  },
  SET_AUTH_USER (state, userObj) {
    state.authUser = userObj
  },
  SET_USER_ALL (state, obj) {
    state.userAll = obj
  },
  SET_ROLE_LIST (state, obj) {
    state.roles = obj
  }
}

const actions = {
  getPositionList: ({ commit }) => {
    console.log(jobPositionUrl)
    axios.get(jobPositionUrl, { headers: getHeader() })
      .then(response => {
        console.log(response.data.data)
        commit('SET_POSITION_USER', response.data.data)
      })
  },
  getRolesList: ({ commit }) => {
    axios.get(roleUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_ROLE_LIST', response.data.data)
      })
  },
  setUserObject: ({ commit }, payload) => {
    commit('SET_AUTH_USER', payload)
  },
  getUserAll: ({ commit }) => {
    axios.get(userUrl, { headers: getHeader() })
      .then(response => {
        console.log(response.data.data)
        commit('SET_USER_ALL', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
